
export default function componentStyleOverrides(theme) {
    const bgColor = theme.colors?.grey50;
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '4px'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                }
            }
        },

        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    border: '4px solid #fff',
                    '&.selected': {
                        borderColor: theme.colors?.primaryDark,

                    }
                }
            }
        },

        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px',
                }
            }
        },

        MuiCardActions: {
            styleOverrides: {
                root: {
                    margin: '24px',
                    width: '25%'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: '12.5px',
                    color: theme.darkTextPrimary,
                    '&:hover': {
                        color: "white"
                    }
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: "6px",
                    paddingBottom: "8px",
                    paddingTop: "8px",
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    borderRadius: '12.5px',
                    margin: "4px",
                    marginLeft: "-1px",
                    "&.sub-item": {
                        width: "100%"
                    },
                    '&.Mui-selected': {
                        backgroundColor: theme.menuItem,
                    },
                    '&:hover': {
                        backgroundColor: theme.menuHover,
                        color: "white"
                    }
                }
            }
        },

        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: "inherit",
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    '&.MuiListItemText-root': {
                        backgroundColor: "inherit",
                        color: "inherit",
                    },
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    '& .MuiDataGrid-row': {
                        '&.Mui-selected': {
                            backgroundColor: theme.menuItem,
                            '&:hover': {
                                backgroundColor: theme.menuHover,
                            },
                        },

                        '&:hover': {
                            backgroundColor: theme.menuHover,
                            color: "white",
                            cursor: "pointer",
                        },
                    }
                }
            }
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: "inherit",
                    '&.Mui-checked': {
                        color: "inherit"
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: bgColor,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.grey400
                    },
                    '&:hover $notchedOutline': {
                        borderColor: theme.colors?.primaryLight
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    }
                },
                input: {
                    fontWeight: 500,
                    background: bgColor,
                    padding: '15.5px 14px',
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primaryLight
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    fontSize: "1.25em",
                    color: "white",
                    marginBottom: "2px"
                }
            }
        },


        MuiAlert: {
            styleOverrides: {
                root: {
                    '&.MuiAlert-filledSuccess': {
                        backgroundColor: theme.success
                    },
                    '&.MuiAlert-filledError': {
                        backgroundColor: theme.error,
                    },

                    '&.MuiAlert-filledWarning': {
                        backgroundColor: theme.warning,
                    },

                    "& .MuiAlert-message": {
                        fontSize: "1em"
                    },

                    '& .MuiAlert-icon':{
                        color: "white"
                    },
                }
            }
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    marginBottom: '0px'
                }
            }
        }

    }
}

